import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import type { SearchReturnRequestsResponseDto } from "@babackapp/private-api-client";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { parseLineItemPriceInCents } from "@babackapp/return-widget-components/utils/get-line-item-price";

type LineItem = SearchReturnRequestsResponseDto["returnRequests"][number]["line_items"][number];

type Props = {
  lineItem: LineItem;
  currency: string;
  imageLayoutId?: string;
};

export function ReturnRequestLineItem({ lineItem, currency, imageLayoutId }: Props) {
  const catalogPriceCents = parseLineItemPriceInCents(lineItem.price);
  const paidPriceCents =
    parseLineItemPriceInCents(lineItem.paidPrice) ?? catalogPriceCents ?? 0;
  const hasDiscount =
    catalogPriceCents != null && catalogPriceCents !== paidPriceCents;

  return (
    <Article variants={{}}>
      {lineItem.image && (
        <ArticleImage src={lineItem.image} layoutId={imageLayoutId} />
      )}
      <ArticleTitle>{lineItem.title}</ArticleTitle>
      <ArticleSubtitle>
        ×{lineItem.quantity} —{" "}
        {hasDiscount && (
          <span className="line-through">
            {formatPrice(catalogPriceCents, currency)}{" "}
          </span>
        )}
        {formatPrice(paidPriceCents, currency)}
      </ArticleSubtitle>
    </Article>
  );
}
